import { UserHelper } from '@/helpers/user.helper';
import { AlertService } from '@/services/alert.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { ErrorBusinessCode, PropertiesManagementService, RealProperty } from '@eemo/api-client';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { InputTrimDirective } from '../../extensions/inputTrimDirective';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

import { NgIf } from '@angular/common';

export class PropertyOwnersDialogData {
  prop: RealProperty;
}

@Component({
    selector: 'app-property-owners-dialog',
    templateUrl: './property-owners-dialog.component.html',
    styleUrls: ['./property-owners-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogModule, FormsModule, ReactiveFormsModule, NgIf, MatIconModule, MatFormFieldModule, MatInputModule, InputTrimDirective, MatButtonModule]
})
export class PropertyOwnersDialogComponent implements OnInit {
  ownersForm: UntypedFormGroup;
  formSubmitting = false;
  UserHelper = UserHelper;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PropertyOwnersDialogData,
    private propMngtService: PropertiesManagementService,
    private alertService: AlertService,
    public userHelper: UserHelper,
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<PropertyOwnersDialogComponent>,
    private dialog: MatDialog
  ) {}

  // convenience getter for easy access to form fields
  f(field: string): AbstractControl {
    return this.ownersForm.get(field);
  }

  ngOnInit() {
    this.ownersForm = this.fb.group({
      coOwnerEmail: ['', Validators.required]
    });

    if (this.data.prop.coOwner !== undefined) {
      // co owner already defined
      this.ownersForm.disable();
    }
  }

  onSubmit() {
    if (this.ownersForm.valid) {
      this.formSubmitting = true;
      this.propMngtService.addRealPropertyOwner(this.data.prop.uid, this.f('coOwnerEmail').value).subscribe(
        (result) => {
          this.dialogRef.close(true);
          this.alertService.success('Co-propriétaire ajouté');
        },
        (err: HttpErrorResponse) => {
          if (err.error && err.error.businessCode && err.error.businessCode === ErrorBusinessCode.EMAIL_NOT_FOUND) {
            this.f('coOwnerEmail').setErrors({ unknown: true });
          } else {
            this.dialogRef.close(false);
          }
        }
      );
    }
  }

  confirmDeleteOwner(ownerId: string, ownerName: string) {
    // prevents to open multiple dialog
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      // width: '25rem',
      data: {
        message: 'Confirmez-vous la suppression propriétaire "' + ownerName + '" ?'
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.doDeleteOwner(ownerId);
      }
    });
  }

  doDeleteOwner(ownerId: string) {
    this.propMngtService.deleteRealPropertyOwner(this.data.prop.uid, ownerId).subscribe((result) => {
      this.dialogRef.close(true);
      this.alertService.success('Co-propriétaire supprimé');
    });
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
